//       function total(params){
//           var url = Urls['v3:banktransaction-total']();
//           return $http({
//               url: url,
//               method: 'GET',
//               params: params,
//               paramSerializer: '$httpParamSerializerJQLike'
//           })
//       }

//       function getYears(params) {
//           var url = Urls['v3:banktransaction-years']();
//           return $http({
//               url: url,
//               method: 'GET',
//               params: params,
//               paramSerializer: '$httpParamSerializerJQLike'
//           });
//       }

//       function destroy(pk) {
//           var url = Urls['v3:banktransaction_detail'](pk);
//           return $http.delete(url);
//       }

//       function activeTimeRange(bankAccountPk) {
//           var url = Urls['v3:banktransaction-active-time-range']()+"?account="+bankAccountPk;
//           return $http.get(url);
//       }
//   }
// })();


import customAxios from "./axiosConfig";

const BankTransactionService = {
  retrieve (transaction_id) {
    const api_url = window.Urls['v3:banktransaction-detail'](transaction_id);
    return customAxios.get(api_url)
  },
  list (params) {
    const api_url = window.Urls['v3:banktransaction-list']();
    return customAxios.get(api_url, { params: params })
  },
  listNextPage (next_url) {
    return customAxios.get(next_url);
  },
  update (data) {
    var api_url = window.Urls['v3:banktransaction-detail'](data.id);
    return customAxios.put(api_url, data);
  },
  suggestedCosts (transaction_id) {
    var api_url = window.Urls['v3:banktransaction-suggested-costs'](transaction_id);
    return customAxios.get(api_url);
  },
  suggestedInvoices (transaction_id) {
    var api_url = window.Urls['v3:banktransaction-suggested-invoices'](transaction_id);
    return customAxios.get(api_url);
  },
  activeTimeRange(bankAccountPk) {
    var api_url = `${window.Urls['v3:banktransaction-active-time-range']()}?account=${bankAccountPk}`;
    return customAxios.get(api_url);
  },
  total(params) {
    var api_url = window.Urls['v3:banktransaction-total']();
    return customAxios.get(api_url, {params: params});
  }
};

export default BankTransactionService;